export const defaultBailiffAllSelector = (state) =>
  state?.defaultBailiffReducer?.defaultBailiffAll;
export const defaultBailiffOpenAddSelector = (state) =>
  state?.defaultBailiffReducer?.defaultBailiffOpenAdd;
export const defaultBailiffOpenEditSelector = (state) =>
  state?.defaultBailiffReducer?.defaultBailiffOpenEdit;
export const defaultBailiffSelectedSelector = (state) =>
  state?.defaultBailiffReducer?.defaultBailiffSelected;
export const defaultBailiffSearchSelector = (state) =>
  state?.defaultBailiffReducer?.defaultBailiffSearch;
export const defaultBailiffDetailSelector = (state) =>
  state?.defaultBailiffReducer?.defaultBailiffDetail;
